import { defineStore } from 'pinia'
import { useRequest } from 'composables/useRequest.js'

const CACHE_TTL = 5 * 60 * 1000

export const useAdminUserInvitationsStore = defineStore('adminUserInvitations', {
  state: () => ({
    records: [],
    page: { current_page: 1, total_pages: 1, total_records: 0, number: 1, limit: 20 },
    search: '',
    sortBy: 'created_at',
    sortOrder: 'DESC',
    fetchedAt: null,
    loading: false,
    error: null,
  }),

  getters: {
    isCacheValid: (state) =>
      state.fetchedAt !== null && Date.now() - state.fetchedAt < CACHE_TTL,
  },

  actions: {
    async fetchIfStale() {
      if (this.isCacheValid && this.records.length > 0) return
      await this.fetchList()
    },

    async fetchList() {
      this.loading = true
      this.error = null
      try {
        const { axiosRequest } = useRequest()
        const payload = {
          sort_by: this.sortBy,
          sort_order: this.sortOrder,
          filters: {},
          page: { limit: this.page.limit, number: this.page.number },
        }
        if (this.search) payload.search = this.search

        const res = await axiosRequest('POST', '/api/v1/admin/user_invitations/list', payload, false)
        if (!res.js_error && res.response.success) {
          this.records = res.response.data.records
          this.page = { ...this.page, ...res.response.data.page }
          this.fetchedAt = Date.now()
        } else {
          this.error = 'Failed to load invitations.'
        }
      } catch {
        this.error = 'Something went wrong.'
      } finally {
        this.loading = false
      }
    },

    // Call after sending or re-inviting so the list refreshes on next visit
    invalidate() {
      this.fetchedAt = null
    },

    setSearch(val) {
      this.search = val
      this.page.number = 1
      this.invalidate()
    },

    setSort(by, order) {
      this.sortBy = by
      this.sortOrder = order
      this.page.number = 1
      this.invalidate()
    },

    goToPage(number) {
      this.page.number = number
      this.invalidate()
    },
  },
})
